var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.customClass") } },
    [
      _c(
        "el-select",
        {
          attrs: {
            multiple: "",
            filterable: "",
            "allow-create": "",
            "default-first-option": "",
          },
          model: {
            value: _vm.optionModel.customClass,
            callback: function ($$v) {
              _vm.$set(_vm.optionModel, "customClass", $$v)
            },
            expression: "optionModel.customClass",
          },
        },
        _vm._l(_vm.cssClassList, function (item, idx) {
          return _c("el-option", {
            key: idx,
            attrs: { label: item, value: item },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }